/**
 * @ignore
 * Created by !daletan on 2/30/93.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const intelligentFormatObj = require('dibs-currency-helpers/intelligentFormatObj');
const getCurrencySymbol = require('dibs-currency-helpers/getCurrencySymbol');
const copy = require('../../constants/contactDealerCopy.json');
const HoldRequestInput = require('./HoldRequestInput').default;
const { variants } = require('../../constants/maytestConstants.es');

class ContactDealerMessage extends React.Component {
    constructor() {
        super();
        this.state = {name: ''};
        this.onNameInput = this.onNameInput.bind(this);
    }

    onNameInput(e) {
        this.setState({name: e.target.value});
    }

    render() {
        const { name } = this.state;
        const { offerExpanded, price, currency, isLoggedIn, onNameEntered, onMessageFocused, nameError, onMessageEntered,
                messageError, displayOffer, onOfferClick, onOfferBlurred, onOfferEntered, offerAmount, error,
                isDealerMessageSending, onContactDealer, type, maytest, sidebar, showRequestHold, isHoldRequestChecked, onHoldRequestClick } = this.props;
        const offerClasses = classNames('pdp-make-offer-wrapper', {expanded: offerExpanded});
        const offerLinkClasses = classNames('pdp-dealer-link', {'offer-link': !offerExpanded});
        const symbol = offerExpanded ? '–' : '+';
        const { currencySymbol, number } = intelligentFormatObj(price, currency);
        const buttonClasses = classNames(
            `button-${maytest === variants.CONTACT2 ? 'small' : 'large'}`,
            `button-${sidebar ? 'secondary' : 'primary'}`,
            'pdp-contact-button', {
                'maytest-contact-button': maytest === variants.CONTACT2,
                'in-sidebar': sidebar
            }
        );

        return (
            <div className="pdp-dealer-section pdp-contact-dealer">
                {maytest === variants.OPOP || maytest === variants.CONTACT2 ? (
                    <div className="pdp-dealer-maytest-opop">
                        {maytest === variants.CONTACT2 && <p className="pdp-contact-dealer-title">Questions about this piece?</p>}
                        {!isLoggedIn &&
                            <div className="pdp-contact-name-wrapper">
                                <input
                                    className="pdp-contact-name maytest-opop-input"
                                    onBlur={onNameEntered}
                                    onFocus={onMessageFocused}
                                    onChange={this.onNameInput}
                                    value={name}
                                />
                                <span className="maytest-opop-input-placeholder">{maytest === variants.CONTACT2 && 'Your '}Name</span>
                                {nameError && <p className="pdp-contact-errors">{copy.errors.isRequired}</p>}
                            </div>
                        }
                    </div>
                ) : (
                    <div>
                        <h1 className="pdp-contact-dealer-title pdp-dealer-message-title">Contact {type}</h1>
                        {!isLoggedIn &&
                            <div className="pdp-contact-name-wrapper">
                                <p className="pdp-contact-instructions">{copy.name}</p>
                                <input
                                    className="pdp-contact-name com-form-input"
                                    onBlur={onNameEntered}
                                    onFocus={onMessageFocused}
                                />
                                {nameError && <p className="pdp-contact-errors">{copy.errors.isRequired}</p>}
                            </div>
                        }
                        <p className="pdp-contact-instructions">{copy.yourMessage}</p>
                    </div>
                )}
                <textarea
                    className="pdp-contact-text"
                    onBlur={onMessageEntered}
                    onFocus={onMessageFocused}
                    placeholder={
                        maytest === variants.CONTACT2 ? `Ask the ${type} a question about this piece.` :
                        `Contact the ${type} to learn more about the history of the piece, request more details or even to discuss the price.`
                    }
                    rows="5"
                />
                {messageError && <p className="pdp-contact-errors">{copy.errors.isRequired}</p>}
                {displayOffer && <p className={offerLinkClasses} onClick={onOfferClick}>{`Make an Offer ${symbol}`}</p>}
                {displayOffer &&
                    <div className={offerClasses}>
                        <p className="pdp-contact-item-price">{`List Price ${currencySymbol}${number}`}</p>
                        <div className="pdp-contact-offer-wrapper">
                            <span className="pdp-contact-offer-currency">{getCurrencySymbol(currency)}</span>
                            <input
                                className="pdp-contact-offer com-form-input"
                                onBlur={onOfferBlurred}
                                onChange={onOfferEntered}
                                value={offerAmount}
                            />
                        </div>
                        <p className="pdp-contact-errors">{error}</p>
                    </div>
                }
                {(sidebar && maytest === variants.CONTACT2 && showRequestHold) &&
                    <HoldRequestInput
                        isHoldRequestChecked={isHoldRequestChecked}
                        onClick={onHoldRequestClick}
                    />
                }
                <button
                    className={buttonClasses}
                    disabled={isDealerMessageSending}
                    onClick={onContactDealer}
                >
                    {maytest === variants.OPOP ? 'Send' : `Send to ${type}`}
                </button>
            </div>
        );
    }
}

ContactDealerMessage.defaultProps = {
    displayOffer: false,
    offerAmount: ''
};

ContactDealerMessage.propTypes = {
    currency: PropTypes.string.isRequired,
    error: PropTypes.string,
    isDealerMessageSending: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    displayOffer: PropTypes.bool,
    hasErrors: PropTypes.bool,
    messageError: PropTypes.bool,
    nameError: PropTypes.bool,
    offerAmount: PropTypes.string,
    offerExpanded: PropTypes.bool.isRequired,
    onContactDealer: PropTypes.func.isRequired,
    onMessageEntered: PropTypes.func.isRequired,
    onMessageFocused: PropTypes.func.isRequired,
    onNameEntered: PropTypes.func.isRequired,
    onOfferBlurred: PropTypes.func.isRequired,
    onOfferClick: PropTypes.func.isRequired,
    onOfferEntered: PropTypes.func.isRequired,
    price: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    maytest: PropTypes.string,
    sidebar: PropTypes.bool,
    showRequestHold: PropTypes.bool,
    isHoldRequestChecked: PropTypes.bool,
    onHoldRequestClick: PropTypes.func
};

module.exports = ContactDealerMessage;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerMessage.jsx